import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${API_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Properties
export const getProperties = async () => {
  const response = await axios.get(`${API}/properties`, { headers: getAuthHeaders() });
  return response.data;
};

export const createProperty = async (data) => {
  const response = await axios.post(`${API}/properties`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const updateProperty = async (id, data) => {
  const response = await axios.patch(`${API}/properties/${id}`, data, { headers: getAuthHeaders() });
  return response.data;
};

// Leases
export const getLeases = async () => {
  const response = await axios.get(`${API}/leases`, { headers: getAuthHeaders() });
  return response.data;
};

export const createLease = async (data) => {
  const response = await axios.post(`${API}/leases`, data, { headers: getAuthHeaders() });
  return response.data;
};

// Messages
export const getMessages = async () => {
  const response = await axios.get(`${API}/messages`, { headers: getAuthHeaders() });
  return response.data;
};

export const createMessage = async (data) => {
  const response = await axios.post(`${API}/messages`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const markMessageRead = async (id) => {
  const response = await axios.patch(`${API}/messages/${id}/read`, {}, { headers: getAuthHeaders() });
  return response.data;
};

// Maintenance Jobs
export const getMaintenanceJobs = async () => {
  const response = await axios.get(`${API}/maintenance-jobs`, { headers: getAuthHeaders() });
  return response.data;
};

export const createMaintenanceJob = async (data) => {
  const response = await axios.post(`${API}/maintenance-jobs`, data, { headers: getAuthHeaders() });
  return response.data;
};

export const updateMaintenanceJob = async (id, data) => {
  const response = await axios.patch(`${API}/maintenance-jobs/${id}`, data, { headers: getAuthHeaders() });
  return response.data;
};

// Contractors
export const getContractors = async () => {
  const response = await axios.get(`${API}/contractors`, { headers: getAuthHeaders() });
  return response.data;
};

export const createContractor = async (data) => {
  const response = await axios.post(`${API}/contractors`, data, { headers: getAuthHeaders() });
  return response.data;
};

// Inspections
export const getInspections = async () => {
  const response = await axios.get(`${API}/inspections`, { headers: getAuthHeaders() });
  return response.data;
};

export const createInspection = async (data) => {
  const response = await axios.post(`${API}/inspections`, data, { headers: getAuthHeaders() });
  return response.data;
};

// Tenants & Landlords
export const getTenants = async () => {
  const response = await axios.get(`${API}/tenants`, { headers: getAuthHeaders() });
  return response.data;
};

export const getLandlords = async () => {
  const response = await axios.get(`${API}/landlords`, { headers: getAuthHeaders() });
  return response.data;
};

// Dashboard Stats
export const getDashboardStats = async () => {
  const response = await axios.get(`${API}/dashboard/stats`, { headers: getAuthHeaders() });
  return response.data;
};

// AI Events
export const getAIEvents = async () => {
  const response = await axios.get(`${API}/ai/events`, { headers: getAuthHeaders() });
  return response.data;
};

export const runArrearsCheck = async () => {
  const response = await axios.post(`${API}/ai/run-arrears-check`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const runLeaseCheck = async () => {
  const response = await axios.post(`${API}/ai/run-lease-check`, {}, { headers: getAuthHeaders() });
  return response.data;
};